import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../button/button.jsx';

import playIcon from './icon--play.svg';
import stopIcon from './icon--stop.svg';
import styles from './play-stop-button.css';

const PlayStopButton = function (props) {
    const {
        active,
        onGreenFlagClick,
        onStopAllClick,
        goTitle,
        stopTitle
    } = props;
    return (
        active ?
            <Button
                className={classNames(styles.btn, styles.stopBtn)}
                iconClassName={styles.icon}
                iconSrc={stopIcon}
                onClick={onStopAllClick}
            >{stopTitle}
            </Button> :
            <Button
                className={classNames(styles.btn, styles.playBtn)}
                iconClassName={styles.icon}
                iconSrc={playIcon}
                onClick={onGreenFlagClick}
            >{goTitle}
            </Button>
        
    );
};
PlayStopButton.propTypes = {
    active: PropTypes.bool,
    goTitle: PropTypes.string,
    onGreenFlagClick: PropTypes.func.isRequired,
    onStopAllClick: PropTypes.func.isRequired,
    stopTitle: PropTypes.string
};
PlayStopButton.defaultProps = {
    active: false
};
export default PlayStopButton;
